module.exports = __webpack_public_path__ + "img/logo.033da2f9.webp";